import React from 'react'
import Button from 'components/Button'
import styled, { css } from 'styled-components'

type Props = {
  icon?: React.ReactElement
  bsStyle?: string
  divider?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const Divider = styled.div`
  flex: 0 0 auto;
  width: 1px;
  height: 20px;
  background-color: #ccc;
  margin: 0 0.5em;
`

const StyledButton = styled(Button)`
  border: none;
  background-color: rgba(255, 255, 255, 0.8);
  margin-left: 5px;

  &:hover,
  &:active,
  &:focus {
    background-color: #fff !important;
    box-shadow: none !important;
  }

  ${props => props.bsStyle === 'primary' ? css`
    color: #2196f3 !important;
  ` : ''}
`

const ViewMenuItem: React.FC<Props> = ({
  icon,
  children,
  divider,
  ...props
}) => {
  if (divider) {
    return <Divider {...props} />
  }

  return (
    <StyledButton
      {...props}
      icon={icon}
    >
      {children}
    </StyledButton>
  )
}

export default ViewMenuItem
